import simbApi from ".";
import { UPDATE_ITEM_SETTINGS, GET_ITEM_SETTINGS } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const getItemSettings = async (access_token: string, itemIds: string[]) => {
  try {
    const response = await simbApi.get(GET_ITEM_SETTINGS, { headers: { Authorization: `Bearer ${access_token}` }, params: { itemid: itemIds[0] } });

    return response?.data?.data;
  } catch (error: any) {
    logger.error("Error getting shared subitems settings:", error);
    throw error;
  }
};

export const updateItemSettings = async (access_token: string, settingKey: string, activeItem: string, checked: boolean) => {
  try {
    const response = await simbApi.post(
      UPDATE_ITEM_SETTINGS,
      { itemid: activeItem, settingKey: settingKey, value: checked },
      { headers: { Authorization: `Bearer ${access_token}` } }
    );

    return response?.data?.data;
  } catch (error: any) {
    logger.error("Error updating item settings:", error);
    throw error;
  }
};
